export const xeroMappingConstants = {
  XERO_MAPPING_CREATE_LOADING: 'XERO_MAPPING_CREATE_LOADING',
  XERO_MAPPING_CREATE_SUCCESS: 'XERO_MAPPING_CREATE_SUCCESS',
  XERO_MAPPING_CREATE_FAILURE: 'XERO_MAPPING_CREATE_FAILURE',
  XERO_MAPPING_ERROR_RELOAD: 'XERO_MAPPING_ERROR_RELOAD',

  XERO_MAPPING_LIST_LOADING: 'XERO_MAPPING_LIST_LOADING',
  XERO_MAPPING_LIST_SUCCESS: 'XERO_MAPPING_LIST_SUCCESS',
  XERO_MAPPING_LIST_FAILURE: 'XERO_MAPPING_LIST_FAILURE',
  XERO_MAPPING_LIST_CLEAR: 'XERO_MAPPING_LIST_CLEAR',

  XERO_MAPPING_EDIT_LOADING: 'XERO_MAPPING_EDIT_LOADING',
  XERO_MAPPING_EDIT_SUCCESS: 'XERO_MAPPING_EDIT_SUCCESS',
  XERO_MAPPING_EDIT_FAILURE: 'XERO_MAPPING_EDIT_FAILURE',

  XERO_MAPPING_DELETE_LOADING: 'XERO_MAPPING_DELETE_LOADING',
  XERO_MAPPING_DELETE_SUCCESS: 'XERO_MAPPING_DELETE_SUCCESS',
  XERO_MAPPING_DELETE_FAILURE: 'XERO_MAPPING_DELETE_FAILURE'
};
